/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlipVertical = createReactComponent("flip-vertical", "IconFlipVertical", [
  ["path", { d: "M12 3l0 18", key: "svg-0" }],
  ["path", { d: "M16 7l0 10l5 0l-5 -10", key: "svg-1" }],
  ["path", { d: "M8 7l0 10l-5 0l5 -10", key: "svg-2" }]
]);

export { IconFlipVertical as default };
//# sourceMappingURL=IconFlipVertical.js.map
